import {AZURE_SCOPES} from 'core/constants';
import {getAzureAuthInstance} from 'core/stores/auth';
import {EnnablLogger} from 'utils/ennabl';

export const azureLogout = () => {
  getAzureAuthInstance()?.logoutRedirect();
};

export const refreshAzureToken = async () => {
  const pcaInstance = getAzureAuthInstance();

  if (!pcaInstance) {
    EnnablLogger.log(['refreshAzureToken', 'No Azure auth instance found']);
    return;
  }

  const account = pcaInstance.getAllAccounts()[0];

  const accessTokenRequest = {
    scopes: AZURE_SCOPES,
    account: account,
  };

  try {
    const response = await pcaInstance.acquireTokenSilent(accessTokenRequest);
    EnnablLogger.log(['refreshAzureToken', 'Successfully acquired token silently'], {response});
    return response.idToken;
  } catch (error) {
    EnnablLogger.error(['refreshAzureToken', 'Silent token acquisition failed, redirecting to login'], {error});
    pcaInstance.loginRedirect(accessTokenRequest);
    return null;
  }
};
